import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Spinner } from '@chilecompra/react-kit'
import routes from '../../config/settings/routes'
import { fixBrokenRouteThunk } from './MiddlewareRoute.actions'

/**
 * MiddlewareRoute container that acts as a route "fixer"
 * for malformed URLs with slashes inside dynamic params (like `rut`).
 */
const MiddlewareRoute = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { redirectTo, calculating } = useSelector(state => state.middlewareRoute)
  const [triedRedirect, setTriedRedirect] = useState(false)

  const tryFixRoute = useCallback(() => {
    dispatch(fixBrokenRouteThunk(location.pathname))
    setTriedRedirect(true)
  }, [dispatch, location.pathname])

  useEffect(() => {
    tryFixRoute()
  }, [tryFixRoute])

  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo, { replace: true })
    }

    if (!redirectTo && triedRedirect) {
      navigate(routes.notFound)
    }
  }, [navigate, redirectTo, triedRedirect])

  if (calculating) return <Spinner />

  return null
}

export default MiddlewareRoute
